"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Representation of the promotion split result.
 *
 * @author ZSr
 * @author Radek Beran
 */


var PromotionSplitDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionSplitDTO, _DomainObject_1$Domai);

  /**
   * @param promotionId
   * @param yearNumber number of year
   * @param weekNumber number of promotion week within the year
   * @param split split ratio on the whole promotion volume for this week;
   * number within interval [0, 1]; sum of all splits for promotion is 1
   * @param splitVolume promo volume that falls into the promotion week according to split
   */
  function PromotionSplitDTO(promotionId, yearNumber, weekNumber, split, splitVolume) {
    var _this;

    _classCallCheck(this, PromotionSplitDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionSplitDTO).call(this));
    _this.promotionId = promotionId;
    _this.yearNumber = yearNumber;
    _this.weekNumber = weekNumber;
    _this.split = split;
    _this.splitVolume = splitVolume;
    return _this;
  }

  return PromotionSplitDTO;
}(DomainObject_1.DomainObject);

exports.PromotionSplitDTO = PromotionSplitDTO;

PromotionSplitDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionSplitDTO.name);
  return {
    promotionId: builder.id('promotionId'),
    yearNumber: builder.num('yearNumber'),
    weekNumber: builder.num('weekNumber'),
    split: builder.bigNum('split'),
    splitVolume: builder.bigNum('splitVolume')
  };
}();